import {
  LayoutDashboard,
  MessageSquare,
  Send,
  Hash,
  Users,
  Megaphone,
  Code2,
  Key,
  ScrollText,
  BarChart3,
  CreditCard,
  Wallet,
  Building2,
  LifeBuoy,
  Layers,
  Shield,
  Store,
  Workflow,
} from 'lucide-react';

export type NavItem = {
  href: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
};

export type NavSection = {
  section: string;
  items: NavItem[];
};

export const NAV_SECTIONS: NavSection[] = [
  {
    section: 'Overview',
    items: [{ href: '/dashboard', label: 'Dashboard', icon: LayoutDashboard }],
  },
  {
    section: 'Messaging',
    items: [
      { href: '/dashboard/contacts', label: 'Contacts', icon: Users },
      { href: '/dashboard/campaigns', label: 'Campaigns', icon: Megaphone },
      { href: '/dashboard/sms', label: 'SMS overview', icon: MessageSquare },
      { href: '/dashboard/sms/send', label: 'Send SMS', icon: Send },
      { href: '/dashboard/sender-ids', label: 'Sender IDs', icon: Hash },
      { href: '/dashboard/channels', label: 'Channels', icon: Layers },
      { href: '/dashboard/ivr', label: 'IVR Studio', icon: Workflow },
    ],
  },
  {
    section: 'Intelligence',
    items: [{ href: '/dashboard/analytics', label: 'Analytics', icon: BarChart3 }],
  },
  {
    section: 'Developers',
    items: [
      { href: '/dashboard/developers', label: 'Overview', icon: Code2 },
      { href: '/dashboard/developers/keys', label: 'API keys', icon: Key },
    ],
  },
  {
    section: 'Billing',
    items: [
      { href: '/dashboard/billing', label: 'Wallet & invoices', icon: Wallet },
      { href: '/dashboard/billing/topup', label: 'Top up', icon: CreditCard },
    ],
  },
  {
    section: 'Administration',
    items: [
      { href: '/dashboard/organization', label: 'Organization', icon: Building2 },
      { href: '/dashboard/support', label: 'Support', icon: LifeBuoy },
      { href: '/dashboard/kyc', label: 'Verification', icon: Shield },
      { href: '/dashboard/audit', label: 'Audit log', icon: ScrollText },
      { href: '/dashboard/team', label: 'Team', icon: Users },
      { href: '/dashboard/reseller', label: 'Reseller', icon: Store },
    ],
  },
];

export function buildCrumbs(pathname: string): Array<{ label: string; href?: string }> {
  if (pathname === '/dashboard') return [{ label: 'Overview' }];
  const parts = pathname.replace(/^\/dashboard\/?/, '').split('/').filter(Boolean);
  return parts.map((part, i) => {
    const href = `/dashboard/${parts.slice(0, i + 1).join('/')}`;
    const label = part.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    const isLast = i === parts.length - 1;
    return { label, href: isLast ? undefined : href };
  });
}
